import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useQuery } from '@tanstack/react-query';

export const GET_FOLDERS_QUERY_KEY = 'folders.getFolders';

export const useGetFolders = ({
  enabled = true,
  page = 1,
  perPage = 1000,
}: { enabled?: boolean; page?: number; perPage?: number } = {}) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  const { data, isLoading, error } = useQuery({
    queryKey: [GET_FOLDERS_QUERY_KEY, { tenantId, page, perPage }],
    queryFn: () => api.folders.listFolders({ tenantId, page, perPage }),
    select: response => response.data,
    enabled: enabled && !!tenantId,
  });

  return {
    folders: data?.folders || [],
    totalCount: data?.pageData?.total,
    isEmpty: data?.pageData?.total === 0,
    isLoading,
    error,
  };
};
